"use client";

import React from "react";
import KeepBanner from "@/components/banners/BannerBase";
const ReadOnlyBanner = () => {
  return <KeepBanner bannerId="read-only-banner" text="Keep is in read-only mode." newWindow={true} data-sentry-element="KeepBanner" data-sentry-component="ReadOnlyBanner" data-sentry-source-file="read-only-banner.tsx" />;
};
export default ReadOnlyBanner;